import { render, staticRenderFns } from "./Attract.vue?vue&type=template&id=d239889e&scoped=true&"
import script from "./Attract.vue?vue&type=script&lang=js&"
export * from "./Attract.vue?vue&type=script&lang=js&"
import style0 from "./Attract.vue?vue&type=style&index=0&id=d239889e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d239889e",
  null
  
)

export default component.exports